import FullScreenDialog, { FullScreenDialogCloseReason } from "../../../components/full-screen-dialog/FullScreenDialog";
import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../../hooks/use-dialog-state/UseDialogState";
import ObjectTagValuesConfigurationEditor from "./ObjectTagValuesConfigurationEditor";

import type { JSX } from "react";

export type ObjectTagValuesConfigurationEditorDialogInitValues = {
    configurationID: number;
    duplicate?: boolean;
};

export type ObjectTagValuesConfigurationEditorDialogResultValues = {
    configurationID: number | undefined;
};

export type ObjectTagValuesConfigurationEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "saveAsNew" | "saveChanges";

export type ObjectTagValuesConfigurationEditorDialogResult = DialogResult<ObjectTagValuesConfigurationEditorDialogResultValues, ObjectTagValuesConfigurationEditorDialogResultReason>;

export type ObjectTagValuesConfigurationEditorDialogProps = DialogProps<ObjectTagValuesConfigurationEditorDialogInitValues, ObjectTagValuesConfigurationEditorDialogResult>;

export default function ObjectTagValuesConfigurationEditorDialog({
    open,
    onClose,
    values
}: ObjectTagValuesConfigurationEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <ObjectTagValuesConfigurationEditor
                configurationID={values?.configurationID}
                duplicate={values?.duplicate}
                onClose={({reason, configurationID}) => onClose({
                    reason: reason,
                    values: {
                        configurationID: configurationID
                    }
                })}
            />
        </FullScreenDialog>
    );
}

export type ObjectTagValuesConfigurationEditorDialogState = DialogState<ObjectTagValuesConfigurationEditorDialogInitValues, ObjectTagValuesConfigurationEditorDialogResult>;
export type BindObjectTagValuesConfigurationEditorDialogReturn = BindDialogReturn<ObjectTagValuesConfigurationEditorDialogInitValues, ObjectTagValuesConfigurationEditorDialogResult>;

export function useObjectTagValuesConfigurationEditorDialogState(): ObjectTagValuesConfigurationEditorDialogState {
    return useDialogState();
}

export function bindObjectTagValuesConfigurationEditorDialog(props: ObjectTagValuesConfigurationEditorDialogState): BindObjectTagValuesConfigurationEditorDialogReturn {
    return bindDialog(props);
}
